import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";


import "./Home.css";

import hero1 from "../images/hero-1.jpg";
import hero2 from "../images/hero-2.jpg";
import hero3 from "../images/hero-3.jpg";
import hero4 from "../images/hero-7.jpg";
import hero5 from "../images/hero-8.jpg";

import about from "../images/about.jpg";

import about1 from "../images/hero-1.jpg";
import about2 from "../images/hero-2.jpg";
import about3 from "../images/hero-3.jpg";

// Product images
import img6724 from "../images/Engine-car/synthetic/6724/pictures_FF6724_1_green_front_1200.jpg";
import img6726 from "../images/Engine-car/synthetic/6726/pictures_FF6726-1_green_front_1200.jpg";
import img6711 from "../images/Engine-car/synthetic/6711/pictures_FF6711-1_green_front_1200.jpg";
import img6702 from "../images/Engine-car/synthetic/6702/pictures_FF6702-1_green_front_1200.jpg";
import img6501 from "../images/Engine-car/synthetic/6501/pictures_FF6501-1_green_front_1200.jpg";
import img6707 from "../images/Engine-car/synthetic/6707/6707_1.png"


const faqs = [
  {
    question: "What types of engine oils does Fanfaro India offer?",
    answer:
      "Fanfaro India offers a wide range of high-performance engine oils including fully synthetic, semi-synthetic, and mineral oils for trucks, buses, passenger cars, and commercial vehicles.",
  },
  {
    question: "Are Fanfaro engine oils compatible with all vehicle brands?",
    answer:
      "Yes. Fanfaro engine oils are formulated to meet international OEM specifications and are compatible with most major vehicle manufacturers. Always check your vehicle manual for the recommended grade and specification.",
  },
  {
    question: "Do Fanfaro products meet international quality standards?",
    answer:
      "Absolutely. Fanfaro lubricants meet and exceed global industry standards such as API and ACEA, ensuring reliable engine protection, improved performance, and longer engine life.",
  },
  {
    question: "Where can I purchase Fanfaro products in India?",
    answer:
      "Fanfaro products are available through our authorized distributors and dealers across India. You can contact us directly to find a distributor near you.",
  },
  {
    question: "Do you offer dealership or bulk purchase options?",
    answer:
      "Yes. We provide dealership opportunities and bulk supply options for workshops, fleet operators, and retailers. Please contact our sales team for partnership details.",
  },
  {
    question: "How can I verify the authenticity of a Fanfaro product?",
    answer:
      "To ensure authenticity, always purchase from authorized dealers. If you have any concerns, contact our support team with product details for verification.",
  },
  {
    question: "How often should engine oil be changed?",
    answer:
      "Oil change intervals depend on the vehicle type, engine condition, and oil grade used. For best performance, follow your vehicle manufacturer’s recommended service schedule.",
  },
];

const slides = [
  {
    image: hero1,
    title: "ENGINE OILS",
    subtitle: "The full list of products",
    link: "/products"
  },

  {
    image: hero3,
    title: "PRODUCTION",
    subtitle: "FULLY IN-HOUSE LUBRICANTS & FLUIDS PRODUCTION",
    link: "/production"
  },
  {
    image: hero5,
    title: "QUALITY CONTROL",
    subtitle: "Three-stage quality control",
    link: "/quality-control"
  },

  {
    image: hero4,
    title: "LUBES TANK FARM.",
    subtitle: "40.000.000 LITERS OF PRODUCTS ARE ALWAYS IN STOCK",
    link: "/lubas-tank-farm"
  },

  {
    image: hero2,
    title: "METAL PACKAGING",
    subtitle: "IN-HOUSE METAL CANISTERS PRODUCTION",
    link: "/metal-packing"
  },
];

const featuredProducts = [
  {
    id: "6501",
    name: "FANFARO TSE 5W-30 6501",
    link: "/engine-oil/synthetic/6501",
    image: img6501,

  },
  {
    id: "6702",
    name: "FANFARO VSX 5W-40 6702",
    link: "/engine-oil/synthetic/6702",
    image: img6702,
  },
  {
    id: "6711",
    name: "FANFARO ESX 0W-40 6711",
    link: "/engine-oil/synthetic/6711",
    image: img6711,
  },
  {
    id: "6724",
    name: "FANFARO NSX 0W-20 6724",
    link: "/engine-oil/synthetic/6724",
    image: img6724,
  },
  {
    id: "6726",
    name: "FANFARO XTR 0W-30 6726",
    link: "/engine-oil/synthetic/6726",
    image: img6726,
  },
  {
    id: "6707",
    name: "FANFARO VDX 5W-30 6707",
link: "/engine-oil/synthetic/6707",
    image: img6707,
  },

];

function Home() {

  const sliderRef = useRef(null);

  /* HERO STATE */
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [length]);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      {/* ================= HERO ================= */}
      <section
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            transform: `translateX(-${current * 100}%)`,
            transition: "transform 0.6s ease-in-out",
          }}
        >
          {slides.map((slide, index) => {
            const isRight = index % 2 === 1; // ✅ alternate

            return (
              <div
                key={index}
                style={{
                  minWidth: "100%",
                  height: "500px",
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative",
                }}
              >
                {/* overlay */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(0,0,0,0.25)",
                  }}
                />

                {/* ✅ BOX */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "40px",

                    left: isRight ? "auto" : "40px",
                    right: isRight ? "40px" : "auto",

                    background: "rgba(4,72,48,.9)",
                    color: "#fff",

                    padding: "30px 40px",
                    width: "520px",
                    maxWidth: "90%",

                    backdropFilter: "blur(8px)",

                    textAlign: isRight ? "right" : "left",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "40px",
                      marginBottom: "10px",
                      color: "#e5e5e5",
                      textAlign: "left",
                    }}
                  >
                    {slide.title}
                  </h1>

                  <p
                    style={{
                      color: "#9acd32",
                      marginBottom: "20px",
                      textAlign: "left",
                    }}
                  >
                    {slide.subtitle}
                  </p>

                  <div style={{ textAlign: "left" }}>
                    <Link
                      to={slide.link}
                      style={{
                        display: "inline-block",
                        background: "#e5e5e5",
                        color: "#000",
                        padding: "12px 30px",
                        textDecoration: "none",
                        fontWeight: "600",
                      }}
                    >
                      DISCOVER
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <section style={{ paddingTop: "50px" }}>
        {/* ✅ SLIDER LINE */}
        <div
          style={{
            position: "absolute",
            // bottom: "91px",
            // top:"10%",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "10px",
            width: "80%",
            zIndex: 10,
          }}
        >
          {slides.map((_, index) => (
            <div
              key={index}
              style={{
                flex: 1,
                height: "3px",
                background:
                  current === index ? "#9acd32" : "rgba(20, 19, 19, 0.94)",
                transition: "0.3s",
                cursor: "pointer",
              }}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </section>

      {/* ================= REST OF YOUR SECTIONS (UNCHANGED) ================= */}

      <section className="section-container">
        <img src={about} alt="about" />
      </section>

      {/* ABOUT */}
      <section className="about section">
        <div className="container about-wrapper">
          <div className="about-images">
            <img src={about1} alt="Campus" className="img-main" />
            <img src={about2} alt="Students" className="img-top" />
            <img src={about3} alt="Events" className="img-bottom" />
          </div>

          <div className="about-content">
            <h2>About Fanfaro </h2>
            <p className="about-intro">
              Fanfaro lubricants are developed using advanced German technology
              to ensure superior engine protection, durability, and performance.
              We are committed to delivering high-quality automotive solutions
              that meet international standards and modern vehicle requirements.
            </p>
          </div>
        </div>
      </section>

      <section className="home-feature-products">
        <div className="feature-header">
          <h2 className="home-feature-heading">Best Sellers</h2>
          <Link to="/car" className="view-all-btn">
            View All
          </Link>
        </div>

        <div className="slider-wrapper">
          <button
            className="slider-btn left"
            onClick={() => sliderRef.current.scrollBy({ left: -220, behavior: "smooth" })}
          >
            ‹
          </button>

          <div className="home-feature-slider" ref={sliderRef}>
            {featuredProducts.map((product) => (
              <Link key={product.id} to={product.link} className="home-feature-card">
                <div className="home-feature-img">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="home-feature-content">
                  <span className="home-feature-name">{product.name}</span>
                  <span className="home-feature-arrow-wrap">
                    <span className="home-feature-arrow">→</span>
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <button
            className="slider-btn right"
            onClick={() => sliderRef.current.scrollBy({ left: 220, behavior: "smooth" })}
          >
            ›
          </button>
        </div>
      </section>

      {/* ================= WHY CHOOSE FANFARO ================= */}
      <section className="why section">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Fanfaro</h2>
            <p>
              We combine passion, expertise, and innovation to deliver
              outstanding experiences that exceed expectations.
            </p>
          </div>

          <div className="why-grid">
            <div className="why-card">
              <div className="why-icon">⭐</div>
              <h3>Advanced Engine Protection</h3>
            </div>

            <div className="why-card">
              <div className="why-icon">⭐</div>
              <h3>High Performance Formula</h3>
            </div>

            <div className="why-card">
              <div className="why-icon">⭐</div>
              <h3>German Quality Standards</h3>
            </div>

            <div className="why-card">
              <div className="why-icon">⭐</div>
              <h3>Reliable & Trusted Brand</h3>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CTA SECTION ================= */}
      <section className="cta section">
        <div className="container cta-wrapper">
          <h2>Ready to Start Your Journey with Fanfaro?</h2>
          <p>
            Join us today and experience unforgettable adventures designed just
            for you.
          </p>

          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">
              Get Started
            </Link>
          </div>
        </div>
      </section>

      {/* ================= FAQ SECTION ================= */}
      <section className="faq section">
        <div className="container max-w-3xl mx-auto px-4 py-16">
          <h2 className="text-3xl font-bold text-center mb-10">
            Frequently Asked Questions
          </h2>

          <div className="faq-list space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? "open" : ""}`}
              >
                <button onClick={() => toggleFAQ(index)}>
                  <span>{faq.question}</span>
                  <span className="faq-icon">
                    {activeIndex === index ? "−" : "+"}
                  </span>
                </button>
                <div className="faq-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>

    </>
  );
}

// const btnStyle = (side) => ({
//   position: "absolute",
//   top: "50%",
//   [side]: "10px",
//   transform: "translateY(-50%)",
//   fontSize: "2rem",
//   background: "rgba(0,0,0,0.4)",
//   color: "#fff",
//   border: "none",
//   padding: "10px",
//   cursor: "pointer",
// });

const navBtn = (side) => ({
  position: "absolute",
  bottom: "40px",
  [side]: "40px",

  background: "rgba(4, 72, 48, 0.4)", // ✅ transparent green
  // backdropFilter: "blur(6px)", // 🔥 glass effect

  color: "#fff",
  border: "1px solid rgba(255,255,255,0.2)",

  padding: "12px 16px",
  cursor: "pointer",
  borderRadius: "50%",
  fontSize: "20px",
  zIndex: 10,

  opacity: 0,
  animation: "fadeIn 0.3s forwards",
  animationDelay: "0.5s",
});

export default Home;
